<template>
  <section v-if="displaySidebar" class="leftArea_wrapper wrapper soft" :class="{collapsed: collapsed}">
    <CollapseButton :collapsed="collapsed" :notice="hasNewMessage" @collapse="collapseSideMenu" :is-left="true" />
    <div v-show="!collapsed">
      <HallsList />
      <DirectMessageWindow />
      <Participants v-if="displayParticipants" />
    </div>
  </section>
</template>

<script>
import CollapseButton from "../modules/CollapseButton"
import HallsList from "../modules/HallsList"
import DirectMessageWindow from "../modules/DirectMessageWindow"
import Participants from "../modules/Participants"

export default {
  name: "Left",
  components: {
    Participants,
    HallsList,
    DirectMessageWindow,
    CollapseButton
  },
  data() {
    return {
      notice: false
    }
  },
  watch: {
    collapsed() {
      this.hasNewMessage = false
    }
  },
  computed: {
    collapsed() {
      return this.$store.getters["sideMenu/left"]
    },
    displayParticipants() {
      const event = this.$store.getters["event/event"]

      if (_.isEmpty(event)) return false

      const displayParticipants = event.display_participants

      if (displayParticipants["all"]) return true
      if (displayParticipants["employee_only"] && this.$store.getters["auth/isAdmin"]) return true
      if (displayParticipants["hidden"]) return false

      return false
    },
    displaySidebar() {
      const event = this.$store.getters["event/event"]

      if (_.isEmpty(event)) return false

      const displaySidebar = event.display_sidebar

      if (displaySidebar["all"]) return true
      if (displaySidebar["employee_only"] && this.$store.getters["auth/isAdmin"]) return true
      if (displaySidebar["hidden"]) return false

      return false
    },
    hasNewMessage: {
      get() {
        return this.$store.getters["directMessages/hasNewMessage"]
      },
      set(newValue) {
        this.$store.commit("directMessages/hasNewMessage", newValue)
      }
    }
  },
  methods: {
    /**
     * 左サイドメニュ開閉処理
     *
     * @returns {void}
     */
    collapseSideMenu() {
      this.$store.commit("sideMenu/collapseByLeft", !this.collapsed)
    }
  }
}
</script>
